module.exports = __webpack_public_path__ + "static/img/mastercard-logo.bcc86c0c.svg";